import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=97417902&scoped=true"
import script from "./upgrade.vue?vue&type=script&lang=js"
export * from "./upgrade.vue?vue&type=script&lang=js"
import style0 from "./upgrade.vue?vue&type=style&index=0&id=97417902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97417902",
  null
  
)

export default component.exports